import { render, staticRenderFns } from "./channelDialog.vue?vue&type=template&id=5f0fcb30&scoped=true"
import script from "./channelDialog.vue?vue&type=script&lang=js"
export * from "./channelDialog.vue?vue&type=script&lang=js"
import style0 from "./channelDialog.vue?vue&type=style&index=0&id=5f0fcb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fcb30",
  null
  
)

export default component.exports